
import { 
    ImageProcessor,
} from "../../base/image_processors_utils.js";

export class DINOv3ViTImageProcessor extends ImageProcessor { }
